<script>
export default {
  name: "Testimonial",
  props: ["testimonial"],
  data: function() {
    return {};
  }
};
</script>
<template>
  <b-card style="margin-top: 4rem; background-color: #f9f9f9; border: none; margin-bottom: 0px" class="testimonials">
    <b-card-img
      :src="require('@/assets/' + testimonial.photo)"
      img-top
      style="display: block; margin: auto; margin-top: -60px; width: 70px"
    />
    <b-card-title :title="testimonial.name" class="text-center" style="font-weight: bold; font-size: 1.25rem; color: #293847"></b-card-title>
    <b-card-text>
      <p id="title">{{testimonial.title}}</p>
      <img src="@/assets/powerdrops/aspas.svg" style="filter: brightness(0.8); margin-bottom: 0.5em;" height="32" width="32" />
      <div id="quote" v-html="testimonial.quote"></div>
    </b-card-text>
  </b-card>
</template>
<style lang="scss">

.testimonials {
  background: #fff;
  margin-bottom: 0px;
  padding-bottom: 0px;
  outline: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  img {
    margin-bottom: 25px;
    max-width: 80px;
    border-radius: 50%;
  }
  #title {
    text-align: center;
    padding: 0;
    margin-bottom: -0.75em;
    font-size: 1em;
  }
  #quote {
    color: #293847;
    font-size: 1.2rem;
    line-height: 1.5rem;
    img {
      margin: 0;
    }
  }
  .nomargin {
    margin: 0;
  }
  .testimonials-box {
    display: flex;
    align-items: center;
    img {
      align-self: center;
      margin-right: 30px;
    }
  }
  .testimonials-info {
    color: #293847;
    display: flex;
    flex-direction: column;
    max-width: 300px;
    .testimonials-name {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 5px;
    }
  }
}
</style>